import mutations from '../mutations';
import api from '../../api';

export default {
  namespaced: true,
  state: {
    loading: false,
    texts: {},
    status: null
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getAll({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.texts
        .getAll(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    detail({ commit }, id) {
      commit(mutations.LOADING);
      return api.texts
        .detail(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    update({ commit }, { id, params }) {
      commit(mutations.LOADING);
      return api.texts
        .update(id, params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    create({ commit }, payload) {
      commit(mutations.LOADING);
      return api.texts
        .create(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    },
    delete({ commit }, id) {
      commit(mutations.LOADING);
      return api.texts
        .delete(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    upload({ commit }, images) {
      commit(mutations.LOADING);
      return api.texts
        .upload(images)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          console.log(error);
          commit(mutations.LOADED);
          return error;
        });
    },
    getMenu({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.texts
        .getMenu(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    getHierarchy({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.texts
        .getHierarchy(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    }
  },
  getters: {}
};
